import React from 'react';
import {connect} from 'react-redux';
import {Status} from '../../redux/_commons/const.js';
import {Map, Marker, Popup, TileLayer, GeoJSON} from 'react-leaflet';
import L from 'leaflet';
import {fetchUpdates} from '../../redux/updates/actions';
import moment from 'moment';
import AlertsList from './AlertsList';
import '../../../node_modules/leaflet/dist/leaflet.css';
import '../../styles/map.less';
import {DEFAULT_BBOX} from '../../config';
import toGeojson from '../../../node_modules/@mapbox/togeojson';

const PLACEMARK_IMAGE_URL = require('../../images/alert-placemark.png');

const AlertPlacemark = L.icon({
  iconUrl : PLACEMARK_IMAGE_URL ,
  iconSize:     [300 / 11, 458 / 11],
  iconAnchor:   [300 / 11 / 2, 458 / 11],
  popupAnchor:  [0, -458 / 11]
});

const geojsonPointToLayer = function(feature, latlng) {
  let marker;
  if(feature.properties.styleUrl === '#beacon' || !feature.properties.styleUrl) {
    marker = `<div class="custom-marker"><div></div><span class="custom-marker__text">${feature.properties.name}</span></div>`;
  }

  if(feature.properties.styleUrl === '#area') {
    marker = `<div class="custom-marker"><span class="custom-marker__text area">${feature.properties.name}</span></div>`;
  }

  let smallIcon = new L.divIcon({
    className: 'my-div-icon',
    html: marker
  })

  return L.marker(latlng, {icon: smallIcon});
};

/** Carte des alertes */
@connect(
  state => ({
    user: state.user,
    updates: state.updates,
    planning: state.planning,
    groomers: state.groomers
  }),
  {fetchUpdates}
)
export default class AlertsMap extends React.Component {

  constructor() {
    super();
    this.state = {
      displayState: 'planning', // planning OR fullscreen OR alerts
      geojson: null,
      geojsonFor: null,
      geojsonLoading: false
    };
  }

  setDisplayState(st) {
    this.setState({
      displayState: st
    });
  }

  /** Force l'actualisation de la carte si les propriétés sont mises à jour */
  componentDidUpdate() {
    if (this.refs.map) {
      this.refs.map.leafletElement.invalidateSize();
    }
    this.loadGeojson();
  }

  loadGeojson() {
    let sr = this.props.user.selectedSkiresort;
    let headers = new Headers();
    let token;

    if (this.state.geojsonFor === sr.id || this.state.geojsonLoading) {
      return;
    }

    try {
      sessionStorage.setItem('safariTest', 'ok');
      token = sessionStorage.getItem('token');
    } catch(e) {
      token = window.STORAGE_TOKEN;
    }
    headers.append('Authorization', `Bearer ${token}`);

    if (sr.has_kmz) {
      fetch(`/api/skiresort/${sr.id}/kmz/doc.kml`, {headers: headers})
        .then(resp => resp.text())
        .then(str => (new window.DOMParser()).parseFromString(str, 'text/xml'))
        .then(xml => {
          this.setState({
            geojson: toGeojson.kml(xml),
            geojsonFor: sr.id,
            geojsonLoading: false
          });
        });
      this.setState({
        geojson: null,
        geojsonFor: null,
        geojsonLoading: true
      });
    } else {
      this.setState({
        geojson: null,
        geojsonFor: sr.id,
        geojsonLoading: false
      });
    }

  }

  componentDidMount() {
    this.loadGeojson();
  }

  /** Renvoie la liste des alertes sélectionnées */
  getAlertsForDay() {
    const {groomers, user} = this.props;
    const selectedDate = user.selectedDate;
    const year = moment(selectedDate).year();
    const month = moment(selectedDate).month() + 1;
    const selectedDay = moment(selectedDate).date();
    let alerts = [];

    groomers.items.forEach(groomer => {
      let key = `${groomer.id}.${year}.${month}`;
      let planning = this.props.planning.get(key);
      if (Status.isAvailable(planning) && planning.get(selectedDay - 1).messages.length > 0) {
        const messages = planning.get(selectedDay - 1).messages;
        messages.map(message => {
          if (message.type === 'ALERT' || message.type === 'MAINTENANCE') {
            alerts.push(message);
          }
        });
      }
    });

    return alerts;
  }

  getMapBoundaries(positions) {
    const {latitude, longitude} = this.props.user.selectedSkiresort;
    let center;
    if (isNaN(latitude) || isNaN(longitude)) {
      center = DEFAULT_BBOX;
    } else if (positions.length > 0) {
      center = [
        [parseFloat(positions[positions.length -1].latitude) - 0.01, parseFloat(positions[positions.length - 1].longitude) - 0.02],
        [parseFloat(positions[positions.length - 1].latitude) + 0.01, parseFloat(positions[positions.length - 1].longitude) + 0.02]
      ];
    } else {
      center = [
        [latitude - 0.01, longitude - 0.02],
        [latitude + 0.01, longitude + 0.02]
      ];
    }
    return new L.LatLngBounds(center);
  }

  render() {
    const { displayState } = this.state;
    const alertsList = this.getAlertsForDay();

    const markerPositions = alertsList.filter(({latitude, longitude}) => latitude != null && longitude != null)
          .sort((a,b) => moment(a.datetimeReceived) > moment(b.datetimeReceived));
    const bounds = this.getMapBoundaries(markerPositions);
    const nonGeoAlertsCount = alertsList.length - markerPositions.length;

    let content = null;
    let changeStateButtons = [];

    if (displayState === 'planning') {
      content = this.props.children;
      changeStateButtons = [
        <div onClick={() => this.setDisplayState('fullscreen')} key={'fullscreen'}>Cacher</div>,
        <div onClick={() => alertsList.length && this.setDisplayState('alerts')}
             className={alertsList.length === 0 ? 'disabled' : ''}
             key={'alerts'}>Voir les alertes →</div>
      ]
    } else if (displayState === 'alerts') {
      content = <AlertsList alerts={ alertsList } resort={ this.props.user.selectedSkiresort }/>;
      changeStateButtons = [
        <div onClick={() => this.setDisplayState('fullscreen')} key={'fullscreen'}>Cacher</div>,
        <div onClick={() => this.setDisplayState('planning')} key={'planning'}>← Voir le planning</div>,
      ]
    } else {
      changeStateButtons = [
        <div onClick={() => this.setDisplayState('alerts')} key={'alerts'}>Voir les alertes</div>,
        <div onClick={() => this.setDisplayState('planning')} key={'planning'}>Voir le planning</div>,
      ];
    }

    return (
      <div style={{height: '100%'}} className={['map-container', displayState !== 'planning' ? 'fullscreen' : null].join(' ')}>
        { content }
        <div className="change-state-buttons">
          { changeStateButtons }
        </div>

        { nonGeoAlertsCount === 0 ? null :
          <div className="non-geo-alerts-count">
            Il y a { nonGeoAlertsCount } alerte(s) non géo-référencée(s)
          </div>
        }
        <Map bounds={bounds} className="alerts-map" ref="map" zoomControl={false} attributionControl={false} onzoomend={() => document.documentElement.style.setProperty('--marker-size',`${Math.exp((this.refs.map.leafletElement.getZoom()-15))+6}px`)}
        >
          { this.state.geojson === null ? null : <GeoJSON data={this.state.geojson} pointToLayer={geojsonPointToLayer}/> }
          <TileLayer
            url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          />
          {
            markerPositions.map(({latitude, longitude, groomerCode, message, details, id, datetimeReceived}) => {
              const position = latitude ? `${parseFloat(latitude).toFixed(6)}, ${parseFloat(longitude).toFixed(6)}` : '--';
              return (
                <Marker position={[Number(latitude), Number(longitude)]} key={id} icon={AlertPlacemark}>
                  <Popup>
                    <div>
                      <div><span>Dameuse</span> { groomerCode } </div>
                      <div><span>Date de réception</span> { datetimeReceived } </div>
                      <div><span>Message</span> { message } </div>
                      <div><span>Details</span> { details } </div>
                      <div><span>Position</span>{ position }</div>
                    </div>
                  </Popup>
                </Marker>
              );
            })
          }
        </Map>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/alerts/AlertsMap.js